module.exports = __webpack_public_path__ + "img/question-mark.28941a66.svg";